/**
 * Turn DB-stored media references into browser URLs.
 * Supports absolute URLs (S3/CDN), blob/data previews, and legacy `/media/` basenames.
 */
export function mediaSrc(stored) {
  if (stored == null || stored === "") return null;
  const s = String(stored).trim();
  if (/^(https?:|blob:|data:)/i.test(s)) return s;
  const clean = s.replace(/^\/+/, "");
  if (clean.startsWith("media/")) return `/${clean}`;
  return `/media/${clean}`;
}
